
import api from '@/plugins/api'
import { Vue, Component } from 'vue-property-decorator'
import MenuModal from '@/modules/menu/MenuModal.vue'
import eventBus from '@/plugins/eventBus'
import { envConfiguration } from '@/plugins/globalStaticDatas'

@Component({
  components: { MenuModal },
})
export default class DailyMenuScreen extends Vue {
  dailyMenu: Object = {}
  envConfigurations: any = envConfiguration

  mounted() {
    setTimeout(() => {
      api()
        .get('daily-menu')
        .then((response) => {
          this.dailyMenu = response.data.data
          setTimeout(() => {
            let maxHeight = window.document.querySelector('.daily-menu-container').clientHeight + 100

            let initialHeight = 0
            let diff = 3
            setInterval(() => {
              window.scroll({
                top: initialHeight,
                left: 0,
                behavior: 'smooth',
              })
              initialHeight += diff
              if (initialHeight > maxHeight) {
                diff = -3
              }
              if (initialHeight < -300) {
                diff = 3
              }
              console.log(initialHeight)
            }, 28)
          }, 5000)
        })
    }, 50000)
  }

  openDailyMenuDetails(product: Object) {
    this.$modal.show('menu-details')
    eventBus.$emit('daily-menu:details', product)
  }
}
